export default __webpack_public_path__ + "static/media/icon-like-poppy.d4cf03d2.webp";